/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import get from 'lodash/get';
import { generateErrorMessage } from 'ui-rating-review/src/utils/error';
import * as api from '../api';
import * as types from '../constants/actions';

export const validateReservation = (number, reservation) => {
    const thunk = () => api.validateReservation(reservation);

    return async (dispatch) => {
        dispatch({ type: `${types.VALIDATE_RESERVATIONS}_START`, number });

        try {
            const response = await thunk();
            const payload = get(response, 'data.errors');

            if (payload === undefined) {
                throw new Error('Did not receive data from server.');
            }

            dispatch({ type: `${types.VALIDATE_RESERVATIONS}_SUCCESS`, payload, number });

            return payload;
        } catch (error) {
            const message = generateErrorMessage(error);
            dispatch({
                error,
                message,
                type: `${types.VALIDATE_RESERVATIONS}_FAILURE`,
                number,
            });

            // Can be caught with try {} catch (error) , or is using Promise syntax with .catch()
            throw new Error(message);
        }
    };
};

export const clearValidationErrors = (number) => ({
    type: types.VALIDATE_RESERVATIONS_CLEAR,
    number,
});
